import { useCallback, useContext, useState } from 'react';

import TooltipContext from '../TooltipContext';

interface Props {
  isOpenOverride?: boolean;
  setIsOpenOverride?: (value: boolean) => void;
  onOpenStateChange?: (isOpen: boolean) => void;
}

const useTooltipState = ({ isOpenOverride, setIsOpenOverride, onOpenStateChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { disableTooltips } = useContext(TooltipContext);

  const changeOpenState = useCallback(
    (nextState: boolean) => {
      setIsOpen(nextState);
      if (setIsOpenOverride) {
        setIsOpenOverride(nextState);
      }
      onOpenStateChange?.(nextState);
    },
    [setIsOpenOverride, onOpenStateChange],
  );

  return {
    isOpen: disableTooltips ? false : (isOpenOverride ?? isOpen),
    openTooltip: useCallback(() => changeOpenState(true), [changeOpenState]),
    closeTooltip: useCallback(() => changeOpenState(false), [changeOpenState]),
  };
};

export default useTooltipState;
